const STORAGE_KEY = 'auth_token';
const STORAGE_EMAIL_KEY = 'auth_email';
const STORAGE_DISPLAY_NAME_KEY = 'auth_display_name';

export interface AuthResult {
    token: string;
    email: string;
    displayName?: string;
    isAdmin: boolean;
}

export class AuthService {
    async login(email: string, password: string, apiBase: string): Promise<AuthResult> {
        const url = `${apiBase.replace(/\/$/, '')}/auth/login`;
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password }),
        });

        if (!response.ok) {
            let message = 'Přihlášení selhalo.';
            try {
                const body = await response.json();
                message = body?.message ?? message;
            } catch {
                // ignore
            }
            throw new Error(message);
        }

        const body = await response.json();
        const token: string = body?.data?.token;
        if (!token) throw new Error('Server nevrátil token.');

        const displayName: string | undefined = body?.data?.displayName || undefined;
        localStorage.setItem(STORAGE_KEY, token);
        localStorage.setItem(STORAGE_EMAIL_KEY, email);
        if (displayName) {
            localStorage.setItem(STORAGE_DISPLAY_NAME_KEY, displayName);
        } else {
            localStorage.removeItem(STORAGE_DISPLAY_NAME_KEY);
        }

        let isAdmin = false;
        try {
            const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
            isAdmin = payload.isAdmin === 'true';
        } catch { /* ignore */ }

        return { token, email, displayName, isAdmin };
    }

    logout(): void {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(STORAGE_EMAIL_KEY);
        localStorage.removeItem(STORAGE_DISPLAY_NAME_KEY);
    }

    getStoredAuth(): AuthResult | null {
        const token = localStorage.getItem(STORAGE_KEY);
        const email = localStorage.getItem(STORAGE_EMAIL_KEY);
        if (!token || !email) return null;

        // Parse JWT payload (base64url) and check expiry
        try {
            const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
            if (payload.exp && Date.now() / 1000 > payload.exp) {
                this.logout();
                return null;
            }
        } catch {
            // Malformed token — clear it
            this.logout();
            return null;
        }

        let isAdmin = false;
        try {
            const payload2 = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
            isAdmin = payload2.isAdmin === 'true';
        } catch { /* ignore */ }

        const displayName = localStorage.getItem(STORAGE_DISPLAY_NAME_KEY) || undefined;
        return { token, email, displayName, isAdmin };
    }
}

